import { render } from "./ReviewsBlock.vue?vue&type=template&id=a2545848"
import script from "./ReviewsBlock.vue?vue&type=script&lang=js"
export * from "./ReviewsBlock.vue?vue&type=script&lang=js"

import "./ReviewsBlock.vue?vue&type=style&index=0&id=a2545848&lang=scss"

import exportComponent from "/codebuild/output/src719114813/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__